import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { invitationsApi, type CreateInvitationBody } from '@/api/invitations.api';

export const invitationKeys = {
  all: ['invitations'] as const,
  list: () => [...invitationKeys.all, 'list'] as const,
};

export function useInvitations() {
  return useQuery({ queryKey: invitationKeys.list(), queryFn: () => invitationsApi.list() });
}

export function useCreateInvitation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateInvitationBody) => invitationsApi.create(body),
    onSuccess: () => {
      toast.success('Invitación creada');
      qc.invalidateQueries({ queryKey: invitationKeys.all });
    },
    onError: (err: Error) => toast.error(err.message || 'Error al crear la invitación'),
  });
}

export function useRevokeInvitation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => invitationsApi.revoke(id),
    onSuccess: () => {
      toast.success('Invitación revocada');
      qc.invalidateQueries({ queryKey: invitationKeys.all });
    },
    onError: (err: Error) => toast.error(err.message || 'Error al revocar'),
  });
}
